import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = authService.getToken();
  if (req.url.includes(environment.apiUrl)) {
    if (token) {
      req = req.clone({
        setHeaders: { Authorization: token } 
      });
    }
    return next(req);
  }

  if (token && req.url.includes(environment.apiUrlCore)) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` } 
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        authService.logout();
        router.navigate(['/login'], { queryParams: { expired: '1' } });
      }
      return throwError(() => error);
    })
  );
};